import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1"
	})
});
export default SvgRadioChecked;
